import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from 'assets/lottie/LoopWhite.json';


export const FullScreenSpinner = ({ onComplete }) => {
  return (
    <div
      id="loading-screen"
      className={`fixed inset-0 flex flex-col items-center justify-center bg-white transition-opacity duration-700 `}
    >
      <Lottie animationData={loadingAnimation} className="" loop />
    </div>
  );
};
